import {
  LabelGrouping,
  LabelType,
  LabelVisibility,
} from '@aibees/elephant/types/label';
import { useMemo, useRef } from 'react';
import { useBootstrapApi } from './use-bootstrap-api';

export function useBootstrapLabels(
  type?: LabelType,
  grouping?: LabelGrouping,
  visibility?: LabelVisibility,
  ids?: string[]
) {
  const api = useBootstrapApi();

  const items = useMemo(() => {
    if (!api.data?.labels) return [];
    let filtered = api.data.labels;
    if (type) filtered = filtered.filter((x) => x.type === type);
    if (grouping) filtered = filtered.filter((x) => x.grouping === grouping);
    if (visibility !== undefined && visibility !== LabelVisibility.ALL)
      filtered = filtered.filter((x) => x.visibility === visibility);
    if (ids) filtered = filtered.filter((x) => ids.includes(x.id));
    return filtered;
  }, [api.data?.labels, grouping, ids, type, visibility]);

  // Stable result: only create new object when items or isLoading actually change
  const prevRef = useRef({ items, isLoading: api.isLoading });
  if (
    prevRef.current.items !== items ||
    prevRef.current.isLoading !== api.isLoading
  ) {
    prevRef.current = { items, isLoading: api.isLoading };
  }
  return prevRef.current;
}
